import { connect } from 'react-redux';
import LoginModal from '../../components/LoginModal';

const mapState = (state) => ({
  isConnected: state.user.isConnected,
});

const mapDispatch = () => ({});

export default connect(mapState, mapDispatch)(LoginModal);
